import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { TableLoader, TableModel } from "../../components/tableLoader";

function ExamSessionSchedule() {
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const [semesterText, setSemesterText] = useState("");

  const loader = {
    title: "Расписание сессии",
    icon: "calendar",
    hideTableWhenEmpty: true,
    request: {
      method: "post",
      path: "/student/exam_session_schedule",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    },
    parser: createModel,
    emptyMessage:
      "Расписание зачетно-экзаменационной сессии будет размещено позже. Следите за информацией.",
  };

  function createModel(response) {
    const table = new TableModel(response);
    table.columns.forEach((column) => {
      if (column.field === "group_module_date") column.type = "date";
    });

    table.rows = [...table.rows].sort(
      (a, b) => new Date(a.group_module_date) - new Date(b.group_module_date),
    );

    const hasRows = response.rows?.length;
    table.description = hasRows
      ? "Уважаемый обучающийся! Вам необходимо пройти промежуточную аттестацию в соответствие с расписанием зачетно-экзаменационной сессии."
      : "";
    table.semester = hasRows ? `${response.semester}` : "";

    return table;
  }

  return <TableLoader {...loader} />;
}

export default ExamSessionSchedule;
